/**
 * 共有リンク作成ダイアログ Step 1「もらう」カード用のイラスト。
 *
 * メタファ: 「相手 → ファイル → あなたの受信箱」の右→左フロー。
 * 「渡す」と矢印の向きが反転していることが視認できるよう、構図は左右対称に揃える。
 *
 * - 線画ベース。色は currentColor で親要素のテキストカラーを継承する。
 * - あなた側に「受信箱（トレイ）」アイコンを足して、もらう = 自分のところに溜まる、
 *   というイメージを補強する。
 * - 受信箱を下に配置するため両者の人型は SEND より一回り小さい (cy=20, r=8)。
 *   頭と肩の接続規則は ShareSendIllust と同じ (apex_y = cy_head + 1)。
 * - ファイルの中身は動画として描く（このプロダクト自体が動画前提のため、
 *   「もらう」も動画素材を受け取る用途が中心になる）。
 */
export function ShareReceiveIllust({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <title>もらう</title>

      <g>
        <circle cx="22" cy="20" r="8" />
        <path d="M6 48 C 6 20, 38 20, 38 48" />
        <path d="M2 54 H42 L38 74 H6 Z" />
        <path d="M14 54 V50 H30 V54" />
      </g>

      <g>
        <path d="M62 44 H102" />
        <path d="M69 38 L62 44 L69 50" />
      </g>

      <g>
        <rect x="108" y="28" width="38" height="32" rx="4" />
        <path d="M140 28 V34 a4 4 0 0 0 4 4 H146" />
        <path d="M118 36 L132 44 L118 52 Z" fill="currentColor" stroke="none" />
      </g>

      <g>
        <circle cx="178" cy="20" r="8" />
        <path d="M162 48 C 162 20, 194 20, 194 48" />
      </g>
    </svg>
  )
}
